import React from "react";
import { ColorPicker } from "~components";
import cn from "classnames";
import { useProductContext } from "~hooks";
import { OUT_OF_STOCK_TEXT } from "~constants/constants";
import * as styles from "./styles.module.scss";

/** ============================================================================
 * @component
 * Product color variant selector widget
 *
 * variant: {title, hex, id, selected}
 * @param  {Variant[]}  variants  			Available color variants
 * @param  {function}  	onChange   			Fired when color is selected, passes in selected color
 * @param  {string}	  	className				For additional styling config
 * @param  {number}	  	quantity				Number of products user wants to add to cart
 * @return {node}
 */

const VariantSelector = ({ variants, onChange, className, quantity }) => {
  const { getVariantData } = useProductContext();

  const selectedVariantId = variants.find(
    (variant) => variant.selected
  )?.variantId;
  const { inventoryQuantity, title } = getVariantData(selectedVariantId) || {};

  const subtitleText = title ? `Selected shade: ${title}` : `Shade:`;

  const isInsufficientStockOfSelectedVariant = inventoryQuantity < quantity;

  return (
    <div className={cn(className)}>
      <div className={cn(`b2`, styles.subtitle)}>{subtitleText}</div>
      <ColorPicker
        className={styles.colorPicker}
        variants={variants}
        onChange={onChange}
        quantity={quantity}
      />
      <p
        className={cn(`caption`, styles.outOfStockText, {
          [styles.visible]: isInsufficientStockOfSelectedVariant
        })}
      >
        {OUT_OF_STOCK_TEXT}
      </p>
    </div>
  );
};

export default VariantSelector;
